/**
 * [BD feat] Legal / long-form content helpers.
 * Wraps RTE tables in a horizontal scroll shell so wide shipping tables
 * don't blow out the 760px measure (mobile + desktop).
 */
(function () {
  var SCROLL_CLASS = 'bd-legal-table-scroll';

  function wrapTable(table) {
    if (!table || table.closest('.' + SCROLL_CLASS)) return;

    var parent = table.parentElement;
    if (parent && (parent.classList.contains('table-container') || parent.classList.contains(SCROLL_CLASS))) {
      parent.classList.add(SCROLL_CLASS);
      return;
    }

    var wrap = document.createElement('div');
    wrap.className = SCROLL_CLASS;
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  }

  function enhance(root) {
    if (!root) return;
    root.querySelectorAll('table').forEach(wrapTable);
  }

  function run(scope) {
    var roots = (scope || document).querySelectorAll('.bd-legal-content__body');
    roots.forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
    });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });
})();
